
import * as constants from "../../assets/constants";
import {baseApi} from "../BaseApi";


class SalePointSellersApi extends baseApi {

    getOne = async (id) => {
        return await this.get(`?app=salePointSellers&act=getOne&id=${id}`)
    }

    getList = async (data) => {
        return await this.post('?app=salePointSellers&act=getList', data)
    }

    save = async (data) => {
        return await this.post('?app=salePointSellers&act=save', {data: JSON.stringify(data)})
    }

    setDeleted = async (id) => {
        return await this.post('?app=salePointSellers&act=setDeleted', {id})
    }

}

export default new SalePointSellersApi(constants.DEBUG?constants.base_url_stage:constants.base_url_prod);
